import addPointIcon from '@/assets/add_point_icon.png';
import { ActionIcon, Image } from "@mantine/core";

export interface AddPointProps {
    onClick: () => void;
}
const AddPoint: React.FC<AddPointProps> = ({onClick}) => {
    return (
        <ActionIcon variant='filled' color='black' size='lg' radius='xl' aria-label='Add Point' style={{ position: 'absolute', bottom: 'calc(33vh + 20px)', right: 20 }} onClick={onClick} >
            <Image src={addPointIcon} alt="Add Point" height={20} style={{ alignSelf: 'center' }} />
        </ActionIcon>
    );
}

export default AddPoint;